import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=733ea25d&scoped=true&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"
import style0 from "../assets/sass/ResetPassword.scss?vue&type=style&index=0&id=733ea25d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733ea25d",
  null
  
)

export default component.exports